export default __webpack_public_path__ + "static/media/seo-h1.feb64ced.svg";